import React from "react";

const ViewMdq = ({ data, ismodalopen, setHtmlModal }) => {
    if (!ismodalopen || !data || !data.json_data) return null;

    const json = data.json_data;

    const closeModal = () => setHtmlModal(false);

const renderYesNo = (key) => (
  <div className="flex space-x-4 mt-2">
    {["Yes", "No"].map((opt) => (
      <span
        key={opt}
        className={`px-4 py-2 rounded-full text-sm font-sans ${
          json[key]?.toLowerCase() === opt.toLowerCase()
            ? "bg-blue-600 text-white border border-blue-600"
            : "bg-white border-2 border-gray-300 text-black"
        }`}
      >
        {opt}
      </span>
    ))}
  </div>
);

    const renderSingleChoice = (key, options) => (
        <div className="flex space-x-4 mt-2">
            {options.map((opt) => (
                <span
                    key={opt}
                    className={`px-4 py-2 rounded-full text-sm font-sans ${
                        json[key] === opt
                            ? "bg-blue-600 text-white border border-blue-600"
                            : "bg-white border-2 border-gray-300 text-black"
                    }`}
                >
                    {opt}
                </span>
            ))}
        </div>
    );

    const questions = [
        {
            q: "Has there ever been a period of time when you were not your usual self and felt so good or so hyper that other people thought you were not your normal self or you were so hyper that you got into trouble?",
            key: "qanswer_5_2",
        },
        {
            q: "You were so irritable that you shouted at people or started fights or arguments?",
            key: "qanswer_5_3",
        },
        {
            q: "You felt much more self-confident than usual?",
            key: "qanswer_5_4",
        },
        {
            q: "You felt much less sleep than usual and found you didn’t really miss it?",
            key: "qanswer_5_5",
        },
        {
            q: "You were much more talkative or spoke faster than usual?",
            key: "qanswer_5_6",
        },
        {
            q: "Thoughts raced through your head or you couldn’t slow your mind down?",
            key: "qanswer_5_7",
        },
        {
            q: "You were so easily distracted by things around you that you had trouble concentrating or staying on track?",
            key: "qanswer_5_8",
        },
        {
            q: "You had much more energy than usual?",
            key: "qanswer_5_9",
        },
        {
            q: "You were much more active or did many more things than usual?",
            key: "qanswer_5_10",
        },
        {
            q: "You were much more social or outgoing than usual, for example, you telephoned friends in the middle of the night?",
            key: "qanswer_5_11",
        },
        {
            q: "You did things that were unusual for you or that other people might have thought were excessive, foolish or risky?",
            key: "qanswer_5_12",
        },
        {
            q: "Spending money got you or your family in trouble?",
            key: "qanswer_5_13",
        },
    ];

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto text-start">
                {/* Header */}
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-2xl font-bold">{json.form_name}</h2>
                    <button onClick={closeModal} className="text-gray-500 hover:text-gray-700">&times;</button>
                </div>

                {/* Patient Info */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                    <div>
                        <label className="font-bold text-base">Patient Name</label>
                        <p className="mb-3">{json.patient_name}</p>
                    </div>
                    <div>
                        <label className="font-bold text-base">Date</label>
                        <p className="mb-3">{json.cdate_5}</p>
                    </div>
                </div>

                {/* Questions */}
                <h3 className="font-bold text-xl mb-4">Instructions: Select the answer that best applies to you.</h3>
                {questions.map((q, idx) => (
                    <div key={idx} className="mb-4">
                        <label className="font-bold text-base">{q.q}</label>
                        {renderYesNo(q.key)}
                    </div>
                ))}

                {/* Same period question */}
                <div className="mb-4">
                    <label className="font-bold text-base">
                        If you checked YES to more than one of the above, have several of these ever happened during the same period of time?
                    </label>
                    {renderYesNo("qanswer_5_14")}
                </div>

                {/* Problem severity */}
                <div className="mb-4">
                    <label className="font-bold text-base">
                        How much of a problem did any of these cause you - like being able to work; having family, money, or legal troubles; getting into arguments or fights?
                    </label>
                    {renderSingleChoice("qanswer_5_15", [
                        "No Problem",
                        "Minor Problem",
                        "Moderate Problem",
                        "Serious Problem",
                    ])}
                </div>

                {/* Family history */}
                <div className="mb-4">
                    <label className="font-bold text-base">
                        Have any of your blood relatives (children, siblings, parents, grandparents, aunts, uncles) had manic-depression illness or bipolar disorder?
                    </label>
                    {renderYesNo("qanswer_5_16")}
                </div>

                {/* Professional diagnosis */}
                <div className="mb-4">
                    <label className="font-bold text-base">
                        Has a health professional ever told you that you have manic depression illness or bipolar disorder?
                    </label>
                    {renderYesNo("qanswer_5_17")}
                </div>
            </div>
        </div>
    );
};

export default ViewMdq;
